import { Injectable } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';
import { CheckinBaseClass } from '../../components';
import { PostJourneysSearchJourneyRequest } from 'src/sdk_checkin';

@Injectable({
  providedIn: 'root',
})
export class CheckinSearchValidationService extends CheckinBaseClass {
  override destroy(): void {
    // 特に必要な処理なし
  }

  /**
   * 予約番号検索：搭乗者名（名）、搭乗者名（姓）の合計桁数が55桁以上の場合はエラーを返す
   *
   * @param control
   * @returns
   */
  travelerNameDigitsValidatorForOrder: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const firstName = control.get('firstNameForOrder');
    const lastName = control.get('lastNameForOrder');
    return this.travelerNameDigitsValidator(firstName, lastName);
  };

  /**
   * 航空券番号検索：搭乗者名（名）、搭乗者名（姓）の合計桁数が55桁以上の場合はエラーを返す
   *
   * @param control
   * @returns
   */
  travelerNameDigitsValidatorForETicket: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const firstName = control.get('firstNameForETicket');
    const lastName = control.get('lastNameForETicket');
    return this.travelerNameDigitsValidator(firstName, lastName);
  };

  /**
   * 搭乗者名（名）、搭乗者名（姓）の合計桁数が55を超える場合はエラーを返す
   *
   * @param firstName
   * @param lastName
   * @returns
   */
  private travelerNameDigitsValidator(
    firstName?: AbstractControl | null,
    lastName?: AbstractControl | null
  ): ValidationErrors | null {
    return firstName?.value?.length + lastName?.value?.length > 55 ? { isNameOverDigits: true } : null;
  }

  /**
   * 現在表示されていない項目かどうかを返す
   *
   * @param formGroup
   * @param searchType
   * @param control
   * @returns
   */
  isDisplayedForm(formGroup: FormGroup, searchType: string, control: FormControl): boolean {
    return (
      !(
        searchType == PostJourneysSearchJourneyRequest.SearchTypeEnum.Order && control == formGroup.get('eTicketNumber')
      ) &&
      !(searchType == PostJourneysSearchJourneyRequest.SearchTypeEnum.ETicket && control == formGroup.get('orderId'))
    );
  }

  /**
   * 無効な値が格納されたFormControlの配列を受け取り、タッチすることでバリデーションエラーメッセージを表示させる
   *
   * @param formControls
   */
  touchInvalidFormControls(formControls: FormControl[]): void {
    formControls.forEach((control) => {
      control.markAsTouched({ onlySelf: true });
    });
  }

  /**
   * 現在表示されているFormControlに対しバリデーションを行い、無効な値が格納されているformControl自身とフィールドのオブジェクトの配列を返す
   * @param formGroup
   * @param searchType
   * @returns
   */
  checkForm(formGroup: FormGroup, searchType: string): Array<{ field: string; control: FormControl }> {
    const controlArray = [];
    for (const field of Object.keys(formGroup.controls)) {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        // 検索条件がorderの際にはeTicketNumberの検証は行わず、検索条件がeTicketの際にはorderIdの検証を行わない
        if (control.invalid && this.isDisplayedForm(formGroup, searchType, control)) {
          controlArray.push({ field: field, control: control });
        }
      } else if (control instanceof FormGroup) {
        controlArray.concat(this.checkForm(control, searchType));
      }
    }
    return controlArray;
  }
}
